setTimeout(() => {
    const searchBar = document.querySelector('cart-form');
    if (searchBar) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
              
                    BSS_B2B.observer.cartSubject.listenCartCheckout();
                }
            });
        });
        observer.observe(searchBar, {
            childList: true
        });
    }

}, 2000)

document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#search-form-sidebar`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});
